import React from "react";

const FactsNumberSection = () => {
  return (
    <section className="section facts-number">
      <div className="facts-left">
        <img
          src="/img/bg/facts-left.png"
          className="img-fluid"
          alt="facts left"
        />
      </div>
      <div className="facts-right">
        <img
          src="/img/bg/facts-right.png"
          className="img-fluid"
          alt="facts right"
        />
      </div>

      <div className="container">
        {/* Heading */}
        <div className="section-heading" data-aos="fade-down">
          <h2 className="title text-white">Omshree Cab In Numbers</h2>
          <p className="description text-white">
            We are proud to provide reliable and trusted cab services to
            thousands of customers with safe and comfortable rides.
          </p>
        </div>

        {/* Counter Group */}
        <div className="counter-group">
          <div className="row">

            {/* Counter 1 */}
            <div className="col-lg-3 col-md-6 col-12 d-flex" data-aos="fade-down">
              <div className="count-group flex-fill">
                <div className="customer-count d-flex align-items-center">
                  <div className="count-img">
                    <img src="/img/icons/bx-heart.svg" alt="Icon" />
                  </div>
                  <div className="count-content">
                    <h4>
                      <span className="counterUp">10</span>K+
                    </h4>
                    <p>Happy Customers</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Counter 2 */}
            <div className="col-lg-3 col-md-6 col-12 d-flex" data-aos="fade-down">
              <div className="count-group flex-fill">
                <div className="customer-count d-flex align-items-center">
                  <div className="count-img">
                    <img src="/img/icons/bx-car.svg" alt="Icon" />
                  </div>
                  <div className="count-content">
                    <h4>
                      <span className="counterUp">150</span>+
                    </h4>
                    <p>Available Cabs</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Counter 3 */}
            <div className="col-lg-3 col-md-6 col-12 d-flex" data-aos="fade-down">
              <div className="count-group flex-fill">
                <div className="customer-count d-flex align-items-center">
                  <div className="count-img">
                    <img src="/img/icons/bx-headphone.svg" alt="Icon" />
                  </div>
                  <div className="count-content">
                    <h4>
                      <span className="counterUp">24</span>/7
                    </h4>
                    <p>Customer Support</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Counter 4 */}
            <div className="col-lg-3 col-md-6 col-12 d-flex" data-aos="fade-down">
              <div className="count-group flex-fill">
                <div className="customer-count d-flex align-items-center">
                  <div className="count-img">
                    <img src="/img/icons/bx-history.svg" alt="Icon" />
                  </div>
                  <div className="count-content">
                    <h4>
                      <span className="counterUp">5</span>L+
                    </h4>
                    <p>Kilometers Covered</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default FactsNumberSection;